/**
 * Все пользовательские строки Mini App. Тон и словарь — BLUEPRINT 3.4:
 * отряд, состав, сбор, сезон, капитан, замена, явка. Короткие командные фразы, без восклицаний.
 * Запрещённые слова проверяются тестом `texts.test.ts` (`FORBIDDEN_WORDS` из @otryad/shared).
 */
export const texts = {
  app: {
    title: 'Отряд',
    tagline: 'Собери состав на сезон',
  },
  common: {
    retry: 'Повторить',
    scrollDown: 'Ниже есть ещё',
    version: 'Версия {version}',
    back: 'Назад',
    next: 'Дальше',
    done: 'Готово',
    cancel: 'Отмена',
    close: 'Закрыть',
    loading: 'Загружаю',
    save: 'Сохранить',
    saved: 'Сохранено',
    open: 'Открыть',
    empty: 'Пока пусто',
    skip: 'Пропустить',
    errorTitle: 'Что-то пошло не так',
    deniedTitle: 'Нет доступа',
    errorBody: 'Проверь связь и попробуй ещё раз',
    notFoundTitle: 'Такого экрана нет',
    notFoundBody: 'Вернись на главный экран',
    toHome: 'На главный',
    copied: 'Ссылка скопирована',
    copy: 'Скопировать',
    share: 'Отправить',
  },
  gate: {
    checking: 'Проверяю доступ',
    authFailedTitle: 'Не удалось войти',
    authFailedBody: 'Telegram не подтвердил запуск. Закрой приложение и открой его снова из бота',
    notInTelegramTitle: 'Открой приложение в Telegram',
    notInTelegramBody: 'Отряд работает только внутри Telegram. Открой бота и нажми «Открыть»',
    openBot: 'Открыть бота',
  },
  nav: {
    home: 'Дом',
    squad: 'Отряд',
    season: 'Сезон',
    profile: 'Профиль',
    pool: 'Ищем состав',
    city: 'Город',
    /** Stage 17: вкладка «Мои сборы» (только с `feature.myGatherings`) */
    my: 'Мои сборы',
  },
  /** Машинные коды ошибок API (`error.data.reason`) → текст */
  errors: {
    unauthorized: 'Telegram не подтвердил вход. Закрой приложение и открой его снова из бота',
    account_blocked: 'Доступ к аккаунту закрыт. Напиши в поддержку',
    venue_account: 'Это аккаунт площадки, приложение участника ему недоступно',
    need_role: 'Это раздел оператора',
    owner_only: 'Это может только владелец',
    need_venue_role: 'Это раздел площадки',
    squad_required: 'Не понял, о каком отряде речь. Открой экран заново',
    city_not_found: 'Город не найден. Выбери другой',
    district_not_in_city: 'Район не из этого города. Проверь выбор',
    activity_not_found: 'Активность недоступна в твоём городе',
    activity_not_primary: 'Эту активность нельзя выбрать основной',
    invalid_squad_size: 'Такого размера отряда нет у этой активности',
    primary_activity_required: 'Выбери основную активность или предложи свою',
    underage: 'Только с 18 лет',
    level_required: 'Укажи уровень по активности',
    pool_limit_reached: 'Лимит заявок: не больше двух наборов одновременно',
    already_applied: 'Заявка на эту активность уже есть',
    cell_mismatch: 'Набор изменился. Обнови список и выбери снова',
    cell_day_not_free:
      'Этот вечер не отмечен у тебя свободным. Добавь его в профиле или выбери набор в свой вечер',
    cell_level_mismatch:
      'Этот набор для другого уровня. Выбери набор своего уровня — так играть будет интереснее',
    already_in_squad: 'Ты уже в отряде по этой активности',
    availability_required: 'Укажи свободные вечера',
    onboarding_required: 'Сначала пройди пять вопросов',
    too_many_pending: 'Слишком много предложений на рассмотрении. Дождись решения',
    already_in_catalog: 'Такая активность уже есть в каталоге. Выбери её на шаге активностей',
    not_found: 'Не найдено',
    not_active: 'Заявка уже закрыта',
    city_required: 'Сначала выбери город',
    squad_not_found: 'Отряд не найден',
    gathering_not_found: 'Сбор не найден',
    season_not_found: 'Сезон не найден',
    not_member: 'Этот человек не в составе',
    self_report: 'Жалоба на самого себя не принимается',
    rsvp_locked: 'Ответ закрыт за 24 часа до сбора. Изменить — через капитана',
    gathering_closed: 'Сбор уже прошёл или отменён',
    season_closed: 'Сезон закрыт',
    invite_not_found: 'Приглашение не найдено',
    invite_used: 'Приглашение уже использовано',
    invite_expired: 'Срок приглашения истёк. Попроси новую ссылку',
    reserve_full: 'Место запасного уже занято',
    reserve_not_available: 'У этого отряда нет места запасного',
    squad_not_open: 'Отряд распущен или на паузе',
    already_member: 'Ты уже в этом составе',
    order_not_found: 'Заказ не найден',
    already_paid: 'Сезон уже оплачен',
    trial_disabled: 'Пробный сбор сейчас закрыт',
    seats_disabled: 'Открытые места сейчас закрыты',
    seat_not_found: 'Место не найдено',
    seat_closed: 'Место больше не доступно',
    seat_taken: 'Место уже занято',
    seat_offered: 'Место держат за другим кандидатом',
    gathering_too_soon: 'До сбора слишком мало времени',
    offered_to_other: 'Место держат за другим кандидатом',
    level_mismatch: 'Уровень отряда далёк от твоего',
    other_city: 'Отряд из другого города',
    /** Раунд персон 1, N3: пробный на сбор уже взят (счёт оплачен или ждёт оплаты) — не «уже идёшь» */
    trial_used: 'Пробный на этот сбор уже взят. Счёт — в «Оплатах и счетах» в профиле',
    already_going: 'Ты уже идёшь на этот сбор',
    squad_full: 'Состав уже полон',
    bad_status: 'Это действие сейчас недоступно. Обнови экран',
    gathering_done: 'Сбор уже завершён',
    gathering_not_started: 'Сбор ещё не начался',
    season_not_active: 'Сезон ещё не запущен — сбор можно завершить, когда он идёт',
    gathering_not_finished: 'Оценить сбор можно, когда он закончится',
    feedback_window: 'Окно обратной связи закрыто: отзыв принимается в течение 12 часов после сбора',
    checkin_window: 'Отметиться можно за полчаса до начала и полчаса после',
    venue_missing: 'Площадка ещё не назначена',
    self_flag: 'Отметить самого себя нельзя',
    self_level: 'Свой уровень капитан не правит',
    level_before_first_gathering: 'Уровень уточняется после первого проведённого сбора',
    level_not_found: 'У участника нет уровня по этой активности',
    flag_not_found: 'Флаг не найден',
    flag_resolved: 'Флаг уже разобран',
    poll_not_found: 'Опрос не найден',
    poll_closed: 'Опрос уже закрыт',
    poll_full: 'Все четыре варианта уже собраны',
    poll_open: 'Опрос о доп. сборе уже идёт',
    group_required: 'Опрос уходит в группу отряда, а её пока нет. Капитан привязывает её в «Отряд» → «Группа в Telegram»',
    extra_overlaps_gathering: 'Одна из дат совпадает по времени со сбором отряда — выбери другое время или день',
    poll_unavailable: 'Опрос названия пока недоступен',
    already_suggested: 'Ты уже предложил вариант',
    duplicate_option: 'Такой вариант уже есть',
    name_set: 'У отряда уже есть название',
    name_too_short: 'Слишком короткое название',
    too_early: 'Название выбирают после второго сбора',
    unknown_option: 'Такого варианта нет',
    not_captain: 'Это делает капитан',
    bad_dates: 'Даты не подходят: нужен запас хотя бы полдня',
    no_opponent: 'У сбора нет соперника',
    gathering_not_done: 'Счёт вносится после сбора',
    opponent_is_self: 'Соперник — другой отряд',
    opponent_set: 'У сбора уже есть соперник',
    promo_not_found: 'Промокод не найден. Проверь буквы и цифры',
    company_already_set: 'Аккаунт уже привязан к другой компании',
    squad_disbanded: 'Отряд распущен',
    // Stage 17, «Мои сборы» (ADR-35): заявка из нескольких разовых мест
    time_conflict: 'Пересекается с твоим сбором. В одно время на два сбора не записаться',
    single_limit: 'Без сезона лимит разовых записей исчерпан. Место в отряде на сезон — без лимита',
    single_limit_gathering: 'На этот сбор разовые места закончились',
    hold_expired: 'Бронь снята: время на оплату вышло. Деньги не списаны',
    feature_disabled: 'Запись на несколько сборов пока закрыта',
    singles_closed: 'Отряд играет этот сбор своим составом',
    squad_not_launched: 'Отряд ещё набирается — разовых мест на его сборах пока нет',
    booking_items_limit: 'В одной заявке столько сборов не поместится. Убери лишние',
    cancel_too_late: 'До сбора меньше суток — выписаться уже нельзя, деньги не возвращаются',
    credited_to_season:
      'Это место уже зачтено в цену сезона — выписаться с возвратом нельзя. Если не получается прийти, напиши в поддержку',
    in_booking: 'Этот сбор уже в твоей брони — другое место на него не добавить',
  },
  /** Раунд персон 2 (M-мелочи): месяц тремя буквами — «1 ноя», а не «1 нояб» */
  months: {
    short: ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  },
  weekdays: {
    short: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
    long: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
    /** «Собираемся во вторник»: винительный падеж с предлогом — «в вторник» и «в среда» неверно */
    on: [
      'в понедельник',
      'во вторник',
      'в среду',
      'в четверг',
      'в пятницу',
      'в субботу',
      'в воскресенье',
    ],
  },
  timeWindows: {
    evening: 'Вечер',
    late: 'Поздний вечер',
    day: 'День',
    morning: 'Утро',
    custom: 'Своё окно',
  },
  onboarding: {
    steps: ['Город', 'Район', 'Вечера', 'Активность', 'О себе'],
    draftRestored: 'Продолжаем с того места, где остановились',
    city: {
      title: 'Твой город',
      subtitle: 'Пока собираем составы здесь. Другие города — позже',
      singleCityHint: 'Один город на старте. Дальше — больше',
      empty: 'Набор пока не открыт ни в одном городе. Бот напишет, когда откроется — закрывать приложение не нужно',
    },
    district: {
      title: 'Где удобно собираться',
      subtitle: 'Выбери до пяти районов. Площадку подберём рядом',
      selected: 'Выбрано: {n}',
      max: 'Не больше пяти районов',
    },
    schedule: {
      title: 'Свободные вечера',
      subtitle: 'Отряд собирается в один и тот же день недели. Отметь все, когда сможешь',
      daysLabel: 'Дни недели',
      windowLabel: 'Окно времени',
      customFrom: 'С',
      customTo: 'До',
      /** Доступные имена полей своего окна: «С» и «До» читаются вне контекста пусто (N10) */
      customFromLabel: 'Свободен с',
      customToLabel: 'Свободен до',
      needDay: 'Отметь хотя бы один день',
      needWindow: 'Окно времени: начало должно быть раньше конца',
      shortWindow: 'Окно короче полутора часов — сбор в него не поместится',
    },
    activities: {
      title: 'Что играем',
      subtitle: 'Одна основная активность — вокруг неё собирается отряд',
      primaryLabel: 'Основная активность',
      sizeLabel: 'Размер отряда',
      sizeOption: '{size} человек',
      sizePair: 'вдвоём',
      sizeFour: 'вчетвером',
      sizeHint: {
        tabletennis2: 'один стол, быстрее соберёмся',
        tabletennis4: 'пары и круг',
      },
      reserveHint: 'Плюс место запасного: {hint}',
      levelLabel: 'Твой уровень',
      levelFor: 'Уровень · {name}',
      interestsLabel: 'Ещё интересно',
      interestsHint:
        'Такие сборы бывают в сезоне между основными: баня, квиз, мастерская. На подбор состава не влияет',
      proposeCta: 'Не нашёл своё? Предложить активность',
      pendingTitle: 'Предложение на рассмотрении',
      pendingBody:
        'Можно выбрать активность из каталога и попасть в набор сейчас, а можно дождаться решения оператора',
      skipPrimary: 'Пропустить выбор и ждать решения',
      skipPrimaryOn: 'Ждём решения по предложению. Основную активность можно выбрать позже',
      needPrimary: 'Выбери основную активность',
      needSize: 'Выбери размер отряда',
      needLevel: 'Укажи уровень',
      stepPrimary: 'Основная активность',
      stepPrimaryHint: 'Вокруг неё собирается отряд — и размер тоже от неё',
      stepLevel: 'Твой уровень',
      stepLevelHint: 'Нужен, чтобы состав играл в одну силу',
      stepInterests: 'Ещё интересно',
      stepExtra: 'Ещё один набор',
      stepExtraHint:
        'Необязательно. Можно ждать состав по двум активностям сразу — очереди идут параллельно',
      extraAdd: 'Добавить набор',
      extraRemove: 'Убрать',
      extraLimit: 'Больше двух наборов одновременно не бывает',
      needExtraSize: 'Выбери размер отряда для второго набора',
      needExtraLevel: 'Укажи уровень по второй активности',
      minLaunch: 'Отряд из {size}. Сезон стартует, если наберётся хотя бы {min}',
    },
    about: {
      title: 'О себе',
      subtitle: 'Телефон видят только капитан и оператор. Составу — только возраст',
      birthYearLabel: 'Год рождения',
      birthYearPlaceholder: '1990',
      ageHint: '{age}',
      phoneLabel: 'Телефон',
      phoneHint: 'Для связи капитана и защиты от ботов. Другим участникам не показывается',
      requestContact: 'Поделиться номером из Telegram',
      phoneShared: 'Номер получен',
      phoneManual: 'Ввести вручную',
      phonePlaceholder: '+7 916 000-00-00',
      phoneDeclined: 'Без номера тоже можно. Капитан свяжется в группе отряда',
      phoneInvalid: 'Телефон в международном формате, например +79160000000',
      rulesTitle: 'Правила состава',
      rules: [
        'Приходи вовремя',
        'Предупреждай о пропуске за 24 часа',
        'Уровень указывай честно',
        'Без агрессии и давления: одна жалоба проверяется, две подтверждённые — исключение без возврата',
        'Капитан может скорректировать твой уровень',
      ],
      agree: 'Принимаю правила состава',
      privacyTitle: 'Персональные данные',
      privacyBody:
        'Имя, возраст, район, вечера и уровень нужны, чтобы собрать тебе состав. Телефон видят только капитан и оператор',
      privacyAgree: 'Согласен на обработку персональных данных',
      privacyLink: 'Политика конфиденциальности',
      needPrivacy: 'Нужно согласие на обработку персональных данных',
      submit: 'В пул',
      submitting: 'Отправляю',
      needRules: 'Нужно принять правила состава',
      needYear: 'Укажи год рождения',
      yearTooYoung: 'Составы собираем с {age} лет',
      yearRange: 'Год рождения — от {min} до {max}',
    },
  },
  pool: {
    title: 'Ищем состав',
    subtitle: 'Как соберётся минимум — бот напишет',
    myCells: 'Твои наборы',
    cellProgress: 'в наборе {count} из {size}',
    cellOf: 'из {size}',
    cellNeeded: 'нужно ещё {left}',
    /** Раунд персон 3 (N4): «1 из 8» и «нужно ещё 5» рядом — про минимум 6 не было сказано */
    cellMinLine: 'Старт от {min} человек — дальше добираем до {size}',
    /** Раунд персон 3 (N9): свои наборы видны карточками выше, в списке города их не повторяем */
    openCellsMine: 'Твои наборы — выше, в этом списке их нет',
    cellPosition: 'ты {position}-й в очереди',
    /** Ревью 2026-09-24: позиция за пределами состава — ждёт следующего состава набора */
    cellPositionNext: 'ты в очереди на следующий состав',
    /** Сверх полного состава: «8 из 8 · ещё 95 в очереди» */
    cellQueue: 'ещё {queue} в очереди — на них соберём следующий состав',
    cellQueueShort: '+{queue} в очереди',
    cellFull: 'набран',
    cellDays: 'вечера: {days}',
    cellLevel: 'уровень {level}',
    cellReady: 'минимум набран',
    /** Полная фраза — строкой в карточке: в значке она разваливалась на четыре строки. */
    cellReadyLong: 'Минимум набран — оператор собирает отряд',
    withdraw: 'Снять заявку',
    cell: {
      title: 'Твой набор',
      subtitle: 'Отряд из {size}',
      ready: 'Людей достаточно — оператор собирает отряд',
      left: 'Нужно ещё {n} до минимума в {min}',
      yours: 'Твои условия',
      level: 'Уровень',
      days: 'Вечера',
      window: 'Окно времени',
      position: 'Ты в очереди',
      waiting: 'В наборе',
      today: 'сегодня',
      eveningHint: 'Отряд будет собираться в один и тот же вечер — скорее всего {weekday}',
      edit: 'Изменить вечера и уровень',
      gone: 'Заявки больше нет: её сняли или отряд уже собран',
    },
    cellOpen: 'Подробнее',
    heroEyebrow: 'Набор · {activity}',
    heroOf: '{count} из {size}',
    /**
     * Почему нельзя в набор — с тем, что делать (раунд 4, N2). Вместо общего «заявка по этой
     * активности уже есть» — чем именно этот набор отличается от своего.
     */
    joinBlock: {
      same_activity: 'Ты уже в наборе по этой активности',
      same_activity_size: 'Твоя заявка по этой активности — на другой размер отряда',
      same_activity_level: 'Твоя заявка по этой активности — другого уровня',
      same_activity_day: 'Этого вечера нет в твоих свободных — добавь его, и заявка встанет сюда',
      in_squad: 'Ты уже в отряде по этой активности',
      limit: 'Уже два набора — это предел. Сними один, чтобы вступить сюда',
      day_not_free: 'Этот вечер не отмечен у тебя свободным — добавь его и вступай',
      other_level: 'Набор другого уровня',
    },
    /** У закрытого набора есть открытый той же активности (`nextCellKey`) */
    joinAlt: 'Есть набор, куда можно сразу: {weekday}, {level}',
    joinAltOpen: 'Открыть набор: {weekday}',
    addEvening: 'Добавить вечер: {weekday}',
    addEveningHint: 'Вечер добавится в профиль и во все твои заявки',
    levelAny: 'любой уровень',
    levelNamed: 'уровень: {name}',
    withdrawTitle: 'Снять заявку из набора?',
    withdrawBody: 'Место в очереди пропадёт. Вернуться в набор можно в любой момент',
    withdrawConfirm: 'Снять',
    noCells: 'Ты ещё не в наборе',
    noCellsBody: 'Выбери активность из открытых наборов или пройди пять вопросов заново',
    toOnboarding: 'Пять вопросов',
    /** Раунд 4, N1: возврат по снятым заявкам с сервера. Заявка новая — очередь с конца, как
     *  и предупреждает окно «Снять заявку» (раньше тут обещали «ту же очередь»). */
    rejoinTitle: 'Вернуться в набор',
    rejoinBody: 'Вечера, районы и уровень — из профиля, заново отвечать не нужно. Место в очереди — с конца',
    rejoinLimit: 'Сейчас два набора — это предел. Сними одну заявку, чтобы вернуться сюда',
    rejoinItem: 'Вернуться: {activity}, {size}',
    proposalsTitle: 'Твои предложения',
    proposalPending: 'На рассмотрении',
    proposalApproved: 'Подтверждено',
    proposalMerged: 'Объединено с «{name}»',
    proposalRejected: 'Отклонено',
    proposalSizes: 'на {sizes}',
    openCells: 'Открытые наборы рядом',
    openCellsBody: 'Наборы города: активность, размер, вечер. Без имён и фото',
    openCellProgress: '{count} из {size}',
    openCellDistricts: 'районы: {districts}',
    join: 'Присоединиться',
    /** Набор заполнен — вступающий встаёт в очередь на следующий состав */
    joinQueue: 'Встать в очередь',
    joinTitle: 'Присоединиться к набору',
    joinBody:
      '{activity}, отряд из {size}, {weekday}. Время и районы — из профиля. Другие твои свободные вечера тоже учтём: так отряд соберётся быстрее',
    joinLevel: 'Твой уровень · {activity}',
    joinConfirm: 'В набор',
    joined: 'Ты в наборе',
    yours: 'Твой набор',
    limitReached: 'Лимит: два набора одновременно',
    /** Экран одного открытого набора: `/pool/open/:cellKey`. */
    openCell: {
      subtitle: 'Набор города · отряд из {size}',
      progressTitle: 'Сколько уже собралось',
      ready: 'Людей достаточно — оператор собирает отряд',
      left: 'Нужно ещё {n} до минимума в {min}',
      terms: 'Условия набора',
      evening: 'Вечер',
      size: 'Размер отряда',
      level: 'Уровень',
      districts: 'Районы',
      districtsAny: 'весь город',
      mine: 'Ты уже в этом наборе',
      gone: 'Набор изменился: людей перераспределили или отряд уже собран',
      toPool: 'К своим наборам',
    },
    noOpenCells: 'Пока других наборов нет. Приведи своего — стартуете раньше',
    whatNext: 'Что дальше',
    whatNextSteps: [
      'Набирается минимум людей на один вечер и уровень',
      'Оператор собирает отряд и назначает капитана',
      'Бот пишет: состав, вечер, расписание сезона, цена',
      'Оплата сезона из 6 сборов — и в группу отряда',
    ],
    /** Ориентир цены до приглашения (раунд 3, N3); цена — из `Setting`/активности через API. */
    priceHint: 'Сезон из {count} — от {price}. Платишь, когда отряд собран',
    referralTitle: 'Приведи своего',
    referralBody: 'Свой в наборе — стартуете быстрее. Бонус обоим на первый сезон',
    referralNoBot: 'Ссылка появится, когда будет настроен бот',
    referralShareText: 'Собираю состав на сезон. Заходи в мой набор',
    openSeatsTitle: 'Открытые места',
    openSeatsBody: 'Кто-то вышел из готового отряда — место можно занять и не ждать набора',
    openSeatsCta: 'Посмотреть места',
    openSeatsShort: 'Занять место в готовом отряде',
    trialTitle: 'Пробный сбор',
    trialBody: 'Один сбор с готовым отрядом, чтобы попробовать. Цена зачтётся в сезон',
    trialCta: 'Найти сбор',
    trialShort: 'Один сбор, цена зачтётся в сезон',
    speedUp: 'Ускорить набор',
    inviteCta: 'Мои приглашённые',
    propose: 'Предложить свою активность',
    profile: 'Профиль',
  },
  propose: {
    title: 'Своя активность',
    subtitle: 'Оператор города ответит за 1–2 дня: подтвердит, объединит с похожей или откажет',
    nameLabel: 'Название',
    namePlaceholder: 'Настольный хоккей',
    descriptionLabel: 'Что это и где обычно проходит',
    descriptionPlaceholder: 'Игра на столе, два игрока. Бары со столами, антикафе',
    sizesLabel: 'Сколько нужно людей',
    sizesHint: 'От 2 до 16, до трёх вариантов',
    /** Раунд персон 3 (N7): кнопка «Отправить оператору» молчала о незаполненном блоке */
    sizesRequired: 'Без этого заявка не уйдёт: выбери хотя бы один размер',
    needsLevelLabel: 'Нужен уровень игры',
    venueHintLabel: 'Где играть (необязательно)',
    venueHintPlaceholder: 'Клуб, бар, зал',
    submit: 'Отправить оператору',
    sentTitle: 'Предложение отправлено',
    sentBody: 'Как оператор решит — бот напишет. Пока можно выбрать активность из каталога',
    sentBodyOnboarded: 'Как оператор решит — бот напишет. Статус — на экране «Ищем состав»',
    backToActivities: 'К выбору активности',
    toPool: 'К статусу набора',
  },
  /**
   * Политика конфиденциальности (`/privacy`). Состав данных и сроки — из `docs/runbooks/privacy.md`
   * и BLUEPRINT 4.5: телефон и Telegram ID наружу не отдаются, телефон стирается через 180 дней
   * без состава и заявки, удаление аккаунта обезличивает профиль.
   */
  privacy: {
    title: 'Политика конфиденциальности',
    updated: 'Обновлено 19 сентября 2026',
    intro:
      'Коротко: мы собираем ровно то, без чего нельзя собрать тебе отряд и провести сезон. Ничего не продаём и не передаём третьим лицам.',
    sections: [
      {
        title: 'Какие данные мы собираем',
        items: [
          'Telegram ID, имя, username и фото профиля — их отдаёт Telegram при входе',
          'Год рождения, город, районы, свободные вечера и уровень по активностям',
          'Телефон — по желанию, для связи капитана и защиты от ботов',
          'Явку на сборах, оценки после сборов и историю оплат сезона',
        ],
      },
      {
        title: 'Как мы их используем',
        items: [
          'Подбираем состав: город, район, вечер, возраст и уровень',
          'Ведём расписание сезона и напоминаем о сборах в чате бота',
          'Считаем явку и надёжность, чтобы состав приезжал',
          'Выставляем счёт за сезон и оформляем чек через платёжного провайдера',
        ],
      },
      {
        title: 'Что видят другие',
        items: [
          'Состав отряда видит имя, возраст, район, уровень и серию явок',
          // Раунд 5, M3: признак оплаты составу больше не отдаётся — по отсутствию метки «оплачен»
          // должник был виден всем. Кто оплатил, а кто нет, видит только капитан
          'В составе на сбор видно ответы «иду / не иду». Кто оплатил сезон, а кто нет, видит только капитан',
          'Телефон видят только капитан и оператор, пока ты в составе или в наборе',
          'Telegram ID, надёжность и заметки оператора не показываются никому',
          'В наборах города и таблице города людей нет — только числа',
        ],
      },
      {
        title: 'Хранение',
        items: [
          'Данные лежат в защищённой базе и используются только для того, что описано выше',
          'Телефон стирается сам через 180 дней без состава и без заявки в наборе',
          'Третьим лицам данные не передаются; платёжному провайдеру уходит только сумма и чек',
        ],
      },
      {
        title: 'Твои права',
        items: [
          'Запросить копию своих данных — по контакту внизу страницы',
          'Удалить аккаунт в любой момент',
          'Отозвать согласие на обработку — это то же удаление аккаунта',
        ],
      },
      {
        title: 'Как удалить данные',
        items: [
          'Профиль → «Удалить аккаунт» → подтверждение',
          'Профиль обезличивается: имя, телефон, фото, год рождения, районы и уровни стираются',
          'История сборов и оплат остаётся обезличенной — этого требует учёт',
          'Оплаченный сезон при удалении не возвращается автоматически: напиши в поддержку',
        ],
      },
    ],
    contactsTitle: 'Контакты',
    contacts: 'Вопросы по данным — в поддержку: @{username}',
    /** Раунд 4, M2: бот свободных сообщений не читает — «оператору в чате бота» было неправдой */
    contactsNone:
      'Вопросы по данным передаст оператору капитан отряда. Удалить данные можно самому: Профиль → «Удалить аккаунт»',
    /** Раунд 5, C1/M1: капитану и человеку без отряда — без отсылки к капитану */
    contactsNoneSelf:
      'Контакта для вопросов по данным в приложении пока нет, сообщения от оператора приходят через бота. Удалить данные можно самому: Профиль → «Удалить аккаунт»',
    close: 'Понятно',
  },
  /** `/pay/success` и `/pay/fail`: страница возврата из платёжной системы (вне Telegram). */
  payReturn: {
    okTitle: 'Оплата прошла',
    okBody: 'Место в составе закреплено за тобой',
    okHint: 'Возвращаем в приложение — расписание сезона уже там',
    countdown: 'Через {n} с',
    failTitle: 'Оплата не прошла',
    failBody: 'Деньги не списаны',
    failHint: 'Вернись в приложение и открой счёт заново — попытка ничего не стоит',
    back: 'Вернуться в приложение',
  },
  /** Корпоративные сезоны (Stage 14, задача 4): лендинг и промокод сотрудника. */
  corp: {
    title: 'Отряд для компании',
    lead: 'Постоянный состав коллег на сезон из {n} сборов. Один раз собрали — дальше играете по расписанию.',
    how: {
      title: 'Как это работает',
      steps: [
        'Оставляете заявку — мы считаем состав и площадки',
        'Выставляем счёт на нужное число мест',
        'Сотрудники входят по промокоду и попадают в отряд компании',
        'Дальше — сезон из {n} сборов: время, площадка, состав и напоминания',
      ],
    },
    price: 'Сезон на человека — {price}. Счёт на компанию, чек и закрывающие документы.',
    cities: 'Города: {list}',
    form: {
      title: 'Заявка',
      company: 'Компания',
      name: 'Как к вам обращаться',
      contact: 'Телефон или @username',
      city: 'Город',
      cityAny: 'Пока не выбрали',
      people: 'Сколько сотрудников будут играть',
      comment: 'Что важно учесть',
      submit: 'Отправить заявку',
      done: 'Заявка принята. Свяжемся по указанному контакту.',
      error: 'Не получилось отправить заявку. Проверьте поля и попробуйте ещё раз.',
    },
    support: 'Вопросы: @{username}',
  },
  /** Промокод компании в профиле участника. */
  company: {
    title: 'Компания',
    hint: 'Промокод выдаёт компания: он ставит сотрудника в отряд коллег и даёт скидку на сезон',
    placeholder: 'Промокод',
    apply: 'Применить',
    applied: 'Компания: {name}',
    discount: 'Скидка на сезон: {pct}%',
    employeesOnly: 'Отряды собираются только из сотрудников',
    mixed: 'Можно попасть в общий отряд города',
  },
  profile: {
    title: 'Профиль',
    subtitle: 'Районы, вечера и уровни. Пока ты в пуле, заявки обновляются вместе с профилем',
    subtitleInSquad: 'Районы, вечера и уровни. Собранный отряд они не меняют — пригодятся в следующем наборе',
    city: 'Город',
    districts: 'Районы',
    schedule: 'Свободные вечера',
    levels: 'Уровни',
    levelValue: 'ур. {level}',
    adjusted: 'капитан скорректировал: {level}',
    streak: 'Серия явок: {n}',
    heroInSquad: 'Участник отряда',
    heroCaptain: 'Капитан отряда',
    heroInPool: 'В наборе',
    /** Раунд 4, N4: заявку сняли — «В наборе» было неправдой */
    heroNoCell: 'Не в наборе',
    subtitleNoCell: 'Районы, вечера и уровни. По ним вернёшься в набор без пяти вопросов',
    edit: 'Изменить',
    editDistricts: 'Районы',
    editSchedule: 'Вечера',
    editLevels: 'Уровни',
    noLevels: 'Уровни появятся после выбора активности',
    phone: 'Телефон',
    phoneSet: 'Указан',
    phoneNotSet: 'Не указан',
    age: 'Возраст',
    attended: 'Сборов посещено: {n}',
    notifications: 'Уведомления',
    notificationsHint: 'Сообщения о наборе, продажах и оплате приходят всегда',
    notify: {
      rsvpRequest: '«Идёшь?» за 48 часов',
      details24h: 'Детали и состав за 24 часа',
      details3h: 'Адрес и что взять за 3 часа',
      feedback: 'Обратная связь после сбора',
    },
    dangerTitle: 'Аккаунт',
    deleteHint: 'Телефон хранится, пока ты в отряде или в пуле, и стирается через полгода после выхода',
    delete: 'Удалить аккаунт',
    deleteConfirmTitle: 'Удалить аккаунт',
    deleteConfirmBody:
      'Ты выйдешь из составов, заявки снимутся, а имя, телефон и фото сотрутся. Неоплаченные счета закроются — не оплачивай их после удаления. Оплаченный сезон не возвращается автоматически: за возвратом — к поддержке. Отменить нельзя',
    deleteConfirm: 'Да, удалить',
    deleted: 'Аккаунт удалён',
  },
  home: {
    title: 'Ближайший сбор',
    noSquadTitle: 'Ты пока не в отряде',
    noSquadBody: 'Статус набора — на экране «Ищем состав»',
    toPool: 'Ищем состав',
    pausedTitle: 'Отряд на паузе',
    pausedBody: 'Оператор поставил отряд на паузу. Как возобновим — бот напишет',
    noSeasonTitle: 'Сезон ещё не открыт',
    noSeasonBody: 'Оператор собирает расписание из 6 сборов. Как откроются продажи — бот напишет',
    finishedTitle: 'Сезон закончен',
    finishedBody: 'Все сборы прошли. Продление сезона появится здесь',
    noUpcomingTitle: 'Сборов впереди нет',
    noUpcomingBody: 'Расписание — на экране «Сезон»',
    startsIn: 'через',
    details: 'Детали сбора',
    mineTitle: 'Твои сборы',
    mineMore: 'Открытые места',
    mineMoreHint: 'Куда можно попасть ещё: место в отряде, замена, пробный сбор',
    seasonTitle: 'Сезон',
    seasonProgress: 'Сезон {number}: {done} из {total}',
    seasonProgressExtra: 'Сезон {number}: {done} из {total} + {extra} доп.',
    seasonOpen: 'Расписание',
    payTitle: 'Сезон не оплачен',
    payCta: 'Оплатить сезон',
    payPending: 'Оплата ждёт подтверждения',
    payPendingHint: 'Если платёж не дошёл или окно закрылось — счёт можно открыть заново',
    paidProgress: 'Оплатили {paid} из {min}, нужных для запуска',
    paidProgressDone: 'Оплат хватает: сезон запустится',
    payContinue: 'Вернуться к оплате',
    paid: 'Сезон оплачен',
    payRefunded: 'Оплата возвращена',
    group: 'Группа отряда',
    groupBody: 'Обсуждения, переносы и «кто едет» — там',
    groupOpen: 'Открыть в Telegram',
  },
  rsvp: {
    question: 'Идёшь?',
    yes: 'Иду',
    no: 'Не иду',
    maybe: 'Думаю',
    changeUntil: 'Ответ можно менять до {when}',
    locked: 'Ответ закрыт за 24 часа до сбора. Изменить — через капитана',
    lockedCaptain: 'Ты капитан: ответы участников правятся в составе на сбор',
    counts: 'идут {yes} · не идут {no} · думают {maybe}',
    needMin: 'нужно минимум {min}',
    /** Раунд 5, M3: правда кода — ответ считается, за неоплату из состава автоматически не снимают */
    unpaidActive:
      'Сезон не оплачен: ответ засчитывается, из состава за это автоматически не снимают. Оплатить можно, пока сезон идёт',
  },
  squad: {
    title: 'Отряд',
    ourEvening: 'Наш вечер',
    evening: '{weekday}, {time}',
    composition: 'Состав',
    captain: 'Капитан',
    noCaptain: 'Капитана назначит оператор',
    params: '{activity} · уровень {level} · {min}–{max} лет',
    districts: 'Районы: {districts}',
    rules: 'Правила состава',
    freeSeats: 'Свободных мест: {n}. Их закрывает оператор — подбирает людей из пула по вашему вечеру и уровню',
    freeSeatsCaptain: 'Свободных мест: {n}. Их закрывает оператор из пула. Позвать своего можно на место запасного',
    reserveMenu: 'Запасной',
    reserveFree: 'место свободно',
    reserveInvited: 'приглашение отправлено',
    reserveTaken: 'место занято',
    heroEyebrow: 'Отряд · {activity}',
    heroOpen: 'Имя и знак отряда',
    group: 'Группа в Telegram',
    groupNone: 'попроси капитана привязать группу',
    groupNoneCaptain: 'ещё не привязана — добавь бота',
    groupNoLinkCaptain: 'привязана, ссылки нет — дай боту право',
    report: 'Пожаловаться',
    reportBody:
      'Жалобу увидит оператор. Одна жалоба проверяется, две подтверждённые — исключение без возврата',
    reportWho: 'На кого',
    reportText: 'Что случилось',
    reportPlaceholder: 'Опоздал на час, спорил, играл не в свой уровень',
    reportSend: 'Отправить оператору',
    reportSent: 'Жалоба отправлена оператору',
    memberStreak: 'серия явок: {n}',
    identityMenu: 'Название и эмблема',
    identityNone: 'выберем после второго сбора',
    identityVote: 'идёт голосование',
    /** Раунд персон 2 (C3): опрос капитана — «Предложить ещё сбор»; «доп. сбор» — только сам сбор */
    extraMenu: 'Предложить ещё сбор',
    extraNone: 'опрос составу в группе отряда',
    extraOpen: 'опрос идёт',
    cityMenu: 'Отряды города',
    streak: 'полным составом подряд: {n}',
    status: {
      FORMING: 'Собираем состав',
      SALE: 'Продажи открыты',
      ACTIVE: 'Сезон идёт',
      PAUSED: 'На паузе',
      DISBANDED: 'Распущен',
    },
  },
  /** Группа отряда в Telegram (раунд 4, C1): кнопка «Добавить бота», права, участнику — без команд */
  group: {
    title: 'Группа в Telegram',
    steps: [
      'Создай группу в Telegram и позови туда состав',
      'Добавь в неё бота — он сам привяжет группу к отряду',
    ],
    addBot: 'Добавить бота в группу',
    rights:
      'Telegram спросит права админа: оставь «Добавление участников» — по нему здесь появится ссылка на группу. Другие права боту не нужны. Если бот промолчал — отправь в группе /bind',
    noBot: 'Создай группу в Telegram, добавь туда бота отряда и отправь в группе /bind',
    boundNoLink:
      'Группа привязана, но ссылки нет: сделай бота админом с правом «Добавление участников» и отправь в группе /bind ещё раз',
    memberNone: 'Группы пока нет. Попроси капитана привязать её',
    memberNoLink: 'Группа привязана. Ссылку попроси у капитана',
  },
  identity: {
    title: 'Название и эмблема',
    subtitle: 'Отряд называет себя сам — оператор в этом не участвует',
    nameTitle: 'Название',
    nameNone: 'Название выбирают после второго сбора',
    nameEarly: 'Проведите два сбора — и предложите варианты. Победит тот, за который проголосуют',
    nameChosen: 'Отряд «{name}»',
    suggest: 'Предложить вариант',
    suggestPlaceholder: 'Соколы',
    suggestHint: 'До {max} символов. Один вариант от каждого, всего четыре',
    suggestSend: 'Предложить',
    suggestedBy: 'предложил свой',
    votes: '{n}',
    vote: 'Голосовать',
    voted: 'Твой голос',
    pollCloses: 'Опрос закрывается {date}',
    pollClosed: 'Опрос закрыт',
    pollWaiting: 'Собираем варианты: {have} из {max}',
    emblemTitle: 'Эмблема',
    emblemHint: 'Выбирает капитан. Знак виден в составе, в таблице города и в напоминаниях',
    emblemNone: 'Эмблему выберет капитан',
    emblemSave: 'Поставить эмблему',
    record: 'Сборов проведено: {done} · полным составом подряд: {streak}',
  },
  extra: {
    title: 'Доп. сбор',
    /** Раунд персон 2 (C3): карточка опроса на экране отряда */
    cardTitle: 'Предложить ещё сбор',
    subtitle: 'Внеплановый сбор вне сезона: оплата на месте',
    hint: 'Опрос уходит в группу отряда. Нужно {min} «да» — тогда сбор появится в расписании',
    activity: 'Чем займёмся',
    dates: 'Когда',
    datesHint: 'До {max} дат, не раньше чем через полдня',
    time: 'Во сколько',
    /** Раунд персон 3 (C10): «Бросить опрос» читалось как «отменить» */
    propose: 'Отправить опрос в группу',
    pollTitle: 'Идёт опрос: {activity}',
    need: 'нужно {min} «да»',
    yes: '«да»: {n}',
    created: 'Сбор собран — он в расписании',
    failed: 'Голосов не хватило',
    addDate: 'Добавить дату',
    /** Раунд 3, C1: группа не привязана — опрос некуда отправить */
    noGroupCaptain: 'Группы отряда пока нет. Привяжи её: «Отряд» → «Группа в Telegram»',
    noGroupMember: 'Группы отряда пока нет. Попроси капитана привязать её',
  },
  city: {
    title: 'Отряды города',
    subtitle: 'Серии полных составов. Рейтингов людей здесь нет и не будет',
    empty: 'В городе пока один отряд — твой',
    emptyBody: 'Как соберутся другие составы, таблица оживёт',
    streak: 'подряд',
    noStreak: 'серии нет',
    done: '{n}',
    seasons: '{n}',
    mine: 'Твой отряд',
    all: 'Все активности',
  },
  renewal: {
    title: 'Продление сезона',
    offer: 'Сезон {number} со скидкой {discount} %',
    price: '{price} вместо {list}',
    deadline: 'Решение до {date}',
    renewed: 'Продлили: {n} из {min}',
    cta: 'Продлить сезон',
    paid: 'Сезон продлён',
    pending: 'Счёт на продление выставлен',
    body:
      'Тот же состав, следующие шесть сборов. Скидка действует до дедлайна — дальше цена обычная',
    dates: 'Сборы с {from} по {to}',
  },
  tournament: {
    title: 'Турнир',
    opponent: 'Соперник: {name}',
    opponentUnnamed: 'Отряд без названия',
    level: 'уровень {level}',
    waiting: 'Соперника подбираем',
    result: 'Счёт: {ours}:{theirs}',
    resultWon: 'Взяли',
    resultLost: 'В следующий раз',
    resultDraw: 'Ничья',
    enterResult: 'Внести счёт',
    ours: 'Мы',
    theirs: 'Соперник',
    note: 'Комментарий',
    notePlaceholder: 'Взяли на тай-брейке',
    save: 'Сохранить счёт',
    saved: 'Счёт сохранён',
  },
  homeScreen: {
    title: 'Ярлык на экран',
    body: 'Добавь «Отряд» на домашний экран — расписание будет в одно нажатие',
    add: 'Добавить',
    later: 'Не сейчас',
  },
  reserve: {
    title: 'Запасной',
    subtitle: 'Постоянный член состава: ходит на все сборы и сменяет по ротации',
    stateFree: 'Место свободно',
    stateInvited: 'Приглашение отправлено',
    stateTaken: 'Место занято',
    stateNone: 'У этого отряда нет места запасного',
    stateNoneBody: 'Запас на явку у этой активности уже заложен в размер отряда',
    expiresIn: 'ссылка истекает через {left}',
    invite: 'Пригласить своего',
    inviteAgain: 'Отправить ссылку ещё раз',
    inviteHint: 'Ссылка одноразовая, живёт {days} дней. Свой проходит пять вопросов и попадает в состав',
    shareText: 'Зову запасным в наш отряд. Открой ссылку — там состав и расписание',
    findInPool: 'Найти запасного в городе',
    findInPoolHint:
      'Место уйдёт в набор города: кандидатам по этой активности и вечеру, а также участникам других отрядов',
    findInPoolSoon: 'Поиск по набору города сейчас закрыт',
    findInPoolDone: 'Место в наборе города — предложим кандидатам по очереди',
    howTitle: 'Как это работает',
    howSteps: [
      'Запасной видит расписание и отвечает «иду / не иду», как все',
      'Ходит на все сборы и сменяет игроков по ротации',
      'Если один из состава не пришёл — сбор состоится',
    ],
    rotation: 'Ротация',
    price: 'Цена сезона для запасного',
    priceHint: '{ratio} от цены сезона ({season})',
    inviteTitle: 'Тебя зовут запасным',
    inviteSquad: '{activity} · {weekday}, {time} · {city}',
    inviteCapacity: 'отряд из {n}',
    invitedBy: 'Позвал {name}',
    invitePrice: 'Сезон для запасного: {price}',
    inviteExpires: 'Ссылка действует до {date}',
    accept: 'Занять место',
    acceptOnboarding: 'Пройти пять вопросов',
    acceptOnboardingHint:
      'Город и активность уже выбраны — останутся районы, вечера, уровень и год рождения',
    acceptedTitle: 'Ты в составе как запасной',
    acceptedBody: 'Расписание и состав — на главном экране',
    toHome: 'На главный',
    problem: {
      not_found: 'Приглашение не найдено',
      expired: 'Срок приглашения истёк. Попроси новую ссылку',
      used: 'Приглашение уже использовано',
      taken: 'Место запасного уже занято',
      squad_closed: 'Отряд распущен или на паузе',
      already_member: 'Ты уже в этом составе',
      already_in_squad: 'Ты уже в другом отряде по этой активности',
    },
  },
  payments: {
    /** Раунд 4, M8: в списке бывают и неоплаченные счета — «Мои оплаты» их прятало в названии */
    title: 'Оплаты и счета',
    subtitle: 'Что оплачено и какие счета ждут оплаты',
    emptyTitle: 'Оплат пока нет',
    emptyBody: 'Здесь появятся оплаты сезонов, пробных сборов и замен',
    /** Раунд персон 3 (N12): внутри заявки к сбору ведут только оплаченные позиции */
    hint: 'Строка ведёт к оплаченному сбору или сезону, а счёт, который ждёт оплаты, — к оплате',
    /** Раунд персон 3 (C12): «скидка 3 750 ₽» рядом с суммой 3 750 ₽ без базовой цены */
    discount: 'скидка {amount}, без неё {list}',
    /** Раунд персон 3 (M5): у счёта, который ждёт оплаты, не было ни срока, ни кнопки */
    holdUntil: 'Места за тобой до {time}',
    payOpen: 'Вернуться к оплате',
    /** Раунд персон 3 (N11): почему заявка закрыта без оплаты */
    closed: {
      hold_expired: 'Бронь истекла — места вернулись в «Открытые места», деньги не списаны',
      replaced: 'Сборы этой брони перешли в новую заявку',
      ops_cancelled: 'Заявку закрыл оператор — места вернулись, деньги не списаны',
      user_cancelled: 'Ты снял заявку — места вернулись в «Открытые места»',
    },
    refunded: 'возвращено {amount}',
    /** Раунд персон 1 (N4): заявка одной строкой, позиции внутри, дата — дата сбора */
    bundleTitle: 'Заявка · {count}',
    gatheringLine: 'Сбор {date}',
    /** Раунд персон 2 (N2): у заявки на несколько сборов — диапазон дат */
    gatheringRange: 'Сборы {from}–{to}',
    gatheringsLine: 'Сборы {date}',
    /** Раунд персон 2 (N2): бронь дописана в новую заявку — не «Отменено» */
    merged: 'Объединена',
    mergedInto: 'Объединена в заявку от {date}',
    itemsLabel: 'Сборы заявки',
    refundDue: 'К возврату',
    kind: {
      SEASON: 'Сезон',
      TRIAL: 'Пробный сбор',
      SUBSTITUTE: 'Замена',
      EXTRA: 'Доп. сбор',
      CORPORATE: 'Корпоративный',
      BUNDLE: 'Заявка на сборы',
      SINGLE: 'Разовое место',
    },
    status: {
      PENDING: 'Ждёт оплаты',
      PAID: 'Оплачено',
      REFUNDED: 'Возвращено',
      PARTIALLY_REFUNDED: 'Частичный возврат',
      CANCELLED: 'Отменено',
      FAILED: 'Не прошло',
    },
    /** Строка на экране сбора: сколько стоил именно он */
    perGathering: 'Твоя оплата: {amount} за этот сбор',
    seasonPaid: 'Сезон оплачен: {total}, {per} за сбор',
    open: 'Все оплаты',
  },
  season: {
    title: 'Сезон',
    number: 'Сезон {number}',
    progress: 'проведено {done} из {total} сборов',
    /** Раунд персон 1, C3: доп. сборы — отдельно, не в знаменателе сезона */
    progressExtra: 'проведено {done} из {total} сборов + {extra} доп.',
    dates: '{from} — {to}',
    price: 'Цена сезона',
    /** Раунд персон 2 (M2): у оплаченного сезона — сумма, которую заплатил */
    pricePaid: 'Оплачено',
    priceWas: 'без скидки {amount}',
    progressDone: 'проведено {done} из {total} сборов',
    deadline: 'Оплата до {date}',
    schedule: 'Расписание',
    extraFormatNote: 'Дополнительный формат сезона — не {activity}',
    /** Раунд 4, M1: турнир — по основной активности, против другого отряда */
    tournamentNote: 'Турнир против другого отряда, формат — {activity}',
    rescheduledNote: 'перенесён',
    cancelledNote: 'отменён: {reason}',
    renew: 'Продлить сезон',
    renewBody: 'Продление откроется после пятого сбора со скидкой за раннее решение. Бот напишет',
    share: 'Поделиться сбором {n}',
    /** Раунд персон 2 (M3): у доп. сбора внутреннего номера наружу нет */
    shareExtra: 'Поделиться доп. сбором',
    shareNone: 'Ближайшего сбора нет',
    /** Раунд персон 3 (C6): впереди несколько сборов — каким делиться, выбирает капитан */
    sharePick: 'Поделиться сбором',
    sharePickTitle: 'Каким сбором поделиться',
    sharePickHint: 'В сообщении будут дата, время и приглашение на свободное место',
    status: {
      DRAFT: 'Черновик',
      SALE: 'Продажи открыты',
      ACTIVE: 'Идёт',
      FINISHED: 'Закончен',
      CANCELLED: 'Отменён',
    },
    payment: {
      NONE: 'Не оплачен',
      PENDING: 'Ждёт оплаты',
      PAID: 'Оплачен',
      REFUNDED: 'Возвращён',
    },
  },
  gathering: {
    title: 'Сбор {n}',
    /** Раунд персон 2 (M4): гостю — сбор чужого отряда, без его номера в сезоне */
    guestTitle: 'Сбор · {squad}',
    when: 'Когда',
    where: 'Где',
    route: 'Маршрут',
    noVenue: 'Площадку уточняем',
    duration: '{min} мин',
    bring: 'Что взять',
    roster: 'Состав на сбор',
    rosterHint: 'Минимум для сбора — {min}',
    /** Раунд персон 3 (M13): «0 из 4 нужных» читалось как недобор отряда — это ответы на сбор */
    quorumLabel: 'Ответили «иду»',
    /** Раунд персон 3 (M3): места не из состава — числом; имена гостей видит только капитан */
    guestsCount: 'Плюс мест не из состава: {n}. В ответы состава они не входят',
    /** Раунд персон 3 (M3): своя строка гостя в составе на сбор */
    youGuest: 'Ты — место не из состава',
    quorumCount: '{yes} из {min} нужных',
    quorumReady: 'Сбор состоится',
    quorumNeed: 'Нужно ещё {n}',
    /** Строка капитана: открытые места отряда (раунд 3, C4) */
    openSeats: 'Открытых мест: {total} · предложено кандидатам: {offered}. Ищем в наборе города',
    rescheduled: 'Сбор перенесён на новую дату',
    cancelled: 'Сбор отменён',
    reason: 'Причина: {reason}',
    done: 'Сбор прошёл',
    opponent: 'Турнир с другим отрядом',
    share: 'Позвать своего',
    /** Раунд персон 1, C4: доп. сбор вне цены сезона — составу */
    paysOnSite: 'Оплата: на месте, вне цены сезона',
    paid: 'оплачен',
    /** Раунд 4, C5: только капитану */
    unpaid: 'не оплатил',
    setForConfirm: 'Записать: {answer}',
    setForPick: 'Выбери ответ',
    /** Имя не склоняем: «Ответ за Игрок 3» (раунд 3, C9) */
    setFor: '{name}: ответ на сбор',
    setForHint: 'Ответ за участника — по его звонку или сообщению. За 24 часа до сбора он сам менять ответ уже не может, и это остаётся только у тебя',
    answered: 'Ответ записан',
    /** Stage 17: запись не из состава — разовое место, замена, пробный */
    myRecordTitle: 'Твоя запись',
    myRecordOpen: 'Заявка',
  },
  /** Капитанский экран явки (Stage 9, задача 1) */
  captain: {
    title: 'Явка на сбор {n}',
    /** Раунд персон 2 (C1): у доп. сбора номера нет */
    titleExtra: 'Явка на доп. сбор',
    subtitle: 'Отметь, кто был. Это влияет на надёжность состава',
    open: 'Отметить явку',
    /** Раунд 4, C4: до окна отметки — когда оно откроется */
    openAt: 'Явка — отметка откроется {when}',
    marked: 'Отмечено {marked} из {total}',
    present: 'Был',
    late: 'Опоздал',
    absent: 'Не был',
    clear: 'Снять отметку',
    marksNotYet: 'Явку отмечают на сборе: отметки откроются за {minutes} минут до начала',
    /** Раунд персон 2 (C4): до окна отметки — над списком, с датой и временем */
    marksOpenAt: 'Отметки откроются {when}',
    geo: 'отметился сам',
    minHint: 'Минимум для сбора — {min}',
    complete: 'Завершить сбор',
    completeHint: 'После завершения состав получит просьбу оценить сбор, а надёжность пересчитается',
    completeNotYet: 'Сбор ещё не начался',
    completed: 'Сбор завершён. Были {present} из {total}',
    level: 'Уточнить уровень',
    levelHint: 'Капитан правит уровень после первого сбора. Участник получит короткое сообщение',
    /** Раунд 4, C2: до первого проведённого сбора отряда кнопки нет — сервер откажет */
    levelNotYet:
      'Уровень можно уточнить после первого проведённого сбора — по игре, а не по анкете',
    levelSaved: 'Уровень уточнён',
    levelAdjusted: 'уровень уточнён',
    rsvpNone: 'без ответа',
    /** Stage 17: капитан закрывает свой сбор для разовых мест */
    singlesTitle: 'Разовые места',
    singlesLabel: 'Пускать разовых на этот сбор',
    /** Раунд персон 2 (C5): сколько мест сбор отдаёт разовым и пробным */
    singlesLabelMax: 'Пускать разовых на этот сбор: до {count}',
    singlesOpen: 'Свободные места продаются разовым через «Открытые места»',
    singlesClosed: 'Отряд играет этот сбор своим составом. Купленные места остаются',
    singlesSaved: 'Сохранено',
    /** Раунд персон 1, C1: люди не из состава на сборе — разовое место, замена, пробный */
    guestsTitle: 'Разовые на сборе',
    guestsLine: 'Разовые: {n} — {names}',
    guestsHint: 'Места не из состава: разовое место, замена, пробный. Их явка не входит в явку состава и надёжность',
    /** Раунд персон 1, C5: блок капитана на экране сбора */
    blockTitle: 'Капитану',
  },
  /** Гео-чек-ин участника (Stage 9, задача 2) */
  checkin: {
    here: 'Я на месте',
    done: 'Ты отмечен на сборе',
    windowHint: 'Отметиться можно за полчаса до начала и полчаса после',
    tooFar: 'До площадки {distance} м — подойди ближе и попробуй ещё раз',
    noLocation: 'Геолокация недоступна. Попроси капитана отметить тебя',
    byCaptain: 'Явку отмечает капитан',
  },
  /** Тихая обратная связь после сбора (Stage 9, задача 3) */
  feedback: {
    title: 'Как прошёл сбор',
    subtitle: 'Три вопроса. Ответы видит только оператор',
    scoreTitle: 'Как прошло',
    scoreHint: '1 — плохо, 5 — отлично',
    withTitle: 'С кем сыграл бы ещё',
    withHint: 'Это влияет на составы дальше. Никто не увидит твой выбор',
    withEmpty: 'Состав на этот сбор пуст',
    flagTitle: 'Был проблемный участник',
    flagHint: 'Скрыто от состава. Разбирает оператор',
    flagAdd: 'Отметить участника',
    flagCancel: 'Убрать отметку',
    flagWho: 'Кто',
    flagKind: 'Что было',
    flagText: 'Что случилось',
    flagPlaceholder: 'Коротко, по фактам',
    kinds: {
      NO_SHOW: 'Не пришёл',
      LATE: 'Опоздал',
      TOXIC: 'Давил, хамил',
      LEVEL_MISMATCH: 'Уровень не тот',
      OTHER: 'Другое',
    },
    submit: 'Отправить',
    submitted: 'Отзыв записан. Спасибо',
    again: 'Изменить ответ',
    toGathering: 'К сбору',
  },
  /** `/open-seats` (Stage 11, задачи 1–3): витрина мест, замен и пробных сборов. */
  seats: {
    title: 'Открытые места',
    subtitle: 'Свободные места в отрядах города: на сезон и на один сбор',
    empty: 'Свободных мест в городе пока нет. Как освободится — бот напишет',
    emptyFiltered: 'По этому фильтру мест нет',
    search: 'Поиск: активность, площадка, район',
    /** Короче подписи поля: на 320 px полная строка обрезалась на «…рай» (раунд 3, N9). */
    searchPlaceholder: 'Активность, площадка, район',
    allActivities: 'Все направления',
    found: 'Нашлось {count}',
    sortHint: 'Ближайшие сборы сверху',
    filters: {
      all: 'Все',
      SEASON: 'В отряд',
      RESERVE: 'Запасным',
      SUBSTITUTE: 'Замена',
      TRIAL: 'Пробный',
      SINGLE: 'Разовые',
    },
    kind: {
      SEASON: 'Место в отряде',
      RESERVE: 'Место запасного',
      SUBSTITUTE: 'Замена на сбор',
      TRIAL: 'Пробный сбор',
      SINGLE: 'Разовое место',
    },
    /** Чем виды отличаются: без этого «замена» и «запасной» различались только на слух. */
    kindHint: {
      SEASON: 'Входишь в состав до конца сезона и платишь долю оставшихся сборов',
      RESERVE: 'Место запасного: выходишь, когда кто-то из состава не может',
      SUBSTITUTE: 'Один сбор вместо того, кто не идёт. Отряд сыгран — от тебя нужно только прийти',
      TRIAL: 'Один сбор, чтобы попробовать формат, а не сезон',
      SINGLE: 'Один сбор в готовом отряде: играешь с ними, отряд не меняешь',
    },
    offeredToMe: 'Держим за тобой',
    offerUntil: 'до {deadline}',
    /** Раунд персон 1 (N9): уровень словом — «уровень: средний» */
    squadLine: '{weekday} {time} · {level}',
    /** Раунд персон 1 (N6): у места на один сбор — одно время, время сбора; вечер отряда не дублируем */
    gatheringLine: '{when} · {level}',
    /** Раунд персон 1 (N12): сбор вне свободных вечеров из анкеты */
    notMyEvening: 'Не твой вечер: в анкете другие дни или время',
    /** Раунд персон 1 (M9/C9): у сбора ещё нет площадки — не обещаем адрес после оплаты */
    venueUnknown: 'Площадку ещё уточняем — адрес появится на экране сбора',
    members: '{count} из {size} в составе',
    // «Впереди 6» читалось как «шесть человек в очереди передо мной» — на карточке, где рядом
    // стоит цена сезона, это отпугивало сильнее всего (разбор пользователя).
    remaining: 'Осталось {count} сборов сезона',
    gathering: '{date}, {time}',
    /** Раунд персон 2 (N9): про адрес — одна формулировка на карточке, в заявке и квитанции */
    venueHidden: 'Адрес — после оплаты: на экране сбора и в напоминании за 3 часа',
    claim: 'Занять за {price}',
    claimSubstitute: 'Подменить за {price}',
    claimTrial: 'Пойти за {price}',
    trialHint: 'Если зайдёт — цена пробного зачтётся в сезон в течение семи дней',
    /** Раунд персон 2 (N6): чем пробный отличается от разового места */
    trialOnce: 'Пробный — один раз на отряд',
    /** Своя активность закрыта правилом «один отряд на активность» — не показываем стену. */
    /** Раунд 4, M4/C3: пробные по этой активности теперь тоже скрыты; замены — показываем */
    hiddenOwn:
      'Места в отряд и пробные сборы по активности твоего отряда не показываем: один отряд на активность. Замены на один сбор — показываем',
    hiddenOwnEmpty: 'Свободных мест по другим активностям сейчас нет',
    hiddenHeld: 'Ещё мест за другими кандидатами: {count}. Если откажутся — места появятся здесь',
    /** Раунд персон 3 (M6): «Ты уже идёшь на этот сбор» — карточка, на которую не записаться */
    hiddenGoing: 'Сборы, на которые ты уже идёшь, не показываем: они в «Моих сборах»',
    /** Раунд персон 3 (N3): на один сбор бывает и пробный, и разовое место — это один сбор */
    foundVariants: 'На часть сборов есть несколько видов мест — берёшь один',
    /** Раунд персон 3 (M7): пустой фильтр выкидывал на главный вместо сброса */
    resetFilter: 'Сбросить фильтр',
    /** Раунд персон 3 (N5/C9): что будет, если состав не соберётся */
    oneOffShortfall:
      'Не соберётся состав — капитан и оператор решают: провести, перенести или отменить. Отменят или перенесут — вернём всю сумму',
    claimHint: 'Оплата картой на странице Робокассы. Пока счёт открыт, место держится за тобой',
    /** Stage 17: запись на несколько сборов одной заявкой (только с `feature.myGatherings`) */
    /** Раунд персон 1 (M7): до оформления это выбор в заявку, а не запись */
    book: 'Добавить · {price}',
    unbook: 'Убрать',
    inBooking: 'В заявке',
    bookHint: 'Выбери один или несколько сборов и оплати их одной ссылкой',
    selection: 'Выбрано {count} · {amount}',
    checkout: 'Оформить',
    selectionLimit: 'В одной заявке до {max} сборов. Оформи эти или убери лишние',
    /** Раунд персон 1: при живой брони место в заявке меньше — бронь дописывается */
    selectionLimitLive: 'В одной заявке до {max} сборов, {live} уже в твоей брони. Оформи эти или убери лишние',
    /** Раунд персон 1 (N13): другое место на уже выбранный сбор — только с согласия */
    replaceTitle: 'Заменить выбранное место?',
    replaceBody: 'На {date} уже выбрано: {from} за {fromPrice}. Один сбор — одно место: вместо него будет {to} за {toPrice}.',
    replaceConfirm: 'Заменить',
    replaceKeep: 'Оставить как было',
    replaced: 'Заменили: теперь на этот сбор — {to}',
    /** Раунд персон 1 (M2/N1): сбор уже в живой брони человека */
    inMyBooking: 'В твоей брони',
    inMyBookingOpen: 'В твоей брони — к заявке',
    inMyBookingHint: 'Бронь ждёт оплаты. Новые сборы допишутся в неё — оплата одной новой ссылкой',
    /** Раунд персон 1 (N5): лимит без сезона — счётчик и причина на карточке */
    /** Раунд персон 2 (N3): дата — когда освободится место в лимите, словами */
    limitCounter: 'Разовых без сезона: {used} из {max}, лимит обновится {date}',
    limitCounterEmpty: 'Без сезона — до {max} разовых мест за {days}',
    limitBlocked: 'Разовых без сезона: {used} из {max}, лимит обновится {date}. В своём отряде на сезон лимита нет',
    limitSeason: 'Места на сезон',
    /** Раунд персон 2 (N3): выход из лимита — свой набор или сезон своего отряда */
    limitToSeason: 'К сезону отряда',
    selectionOver: 'Сверх лимита: {count} — в заявку не войдут',
    singleAnchor: 'Место в сезоне дешевле: {share} за сбор',
    /** Экран одного предложения `/open-seats/:key`: всё, что нужно до оплаты. */
    detail: {
      priceTitle: 'Сколько и за что',
      priceSeason: 'Доля сезона: осталось {left} сборов из {total}. Дальше — продление вместе с отрядом',
      priceSubstitute: 'Один сбор. В сезон не засчитывается, дальше ничего не списывается',
      priceSingle:
        'Один сбор, дальше ничего не списывается. Купишь сезон в течение {days} после оплаты — эту сумму зачтём',
      squadTitle: 'Отряд',
      members: 'Состав',
      level: 'Уровень',
      eveningRow: 'Вечер',
      evening: '{weekday}, {time}',
      gatherings: 'Сборов в сезоне',
      gatheringsValue: 'осталось {left} из {total}',
      when: 'Когда',
      back: 'Ко всем местам',
      gone: 'Предложение уже закрыто: место заняли или сбор прошёл',
    },
    blocked: {
      offered_to_other: 'Место держат за другим кандидатом',
      already_member: 'Ты уже в этом отряде',
      already_in_squad: 'Ты уже в отряде по этой активности',
      level_mismatch: 'Уровень отряда далёк от твоего',
      other_city: 'Другой город',
      onboarding_required: 'Сначала пройди онбординг',
      trial_used: 'Пробный на этот сбор уже взят',
      already_going: 'Ты уже идёшь на этот сбор',
      squad_full: 'Состав уже полон',
    },
    toPool: 'К своему набору',
  },
  /** `/invite` (Stage 11, задача 4): ссылка и статус приглашённых. */
  invite: {
    title: 'Приведи своего',
    subtitle: 'Друг попадёт в твой отряд, если есть место, — бонус обоим',
    linkTitle: 'Твоя ссылка',
    linkBody: 'Отправь её тому, с кем хочешь играть. Бонус придёт после его первой оплаты',
    noBot: 'Ссылка появится, когда будет настроен бот',
    bonusTitle: 'Бонус',
    bonusAvailable: 'К списанию с ближайшего заказа: {amount}',
    bonusNone: 'Бонус появится после первой оплаты приглашённого',
    bonusEach: 'За каждого приглашённого — {amount} обоим',
    invitedTitle: 'Кто пришёл по ссылке',
    invitedEmpty: 'Пока никто не пришёл по ссылке',
    invitedPaid: 'Оплатил',
    invitedWaiting: 'Ещё не оплатил',
    invitedInSquad: 'В твоём отряде',
    invitedBonusUsed: 'Бонус списан',
    invitedBy: 'Тебя привёл {name}',
    invitedByEarned: 'Бонус за твою первую оплату уже начислен',
    invitedByWaiting: 'Бонус придёт после твоей первой оплаты',
    shareText: 'Собираем постоянный состав на сезон. Заходи',
  },
  pay: {
    title: 'Оплата сезона',
    includes: 'Что входит',
    includesGatherings: '{count} по расписанию',
    includesItems: ['Площадки и бронь', 'Группа отряда и напоминания бота'],
    perGathering: '{amount} за сбор',
    price: 'Цена',
    reservePrice: 'Цена для запасного',
    captainDiscount: 'Скидка капитана: −{amount}',
    trialCredit: 'Зачёт пробного сбора: −{amount}',
    referralBonus: 'Бонус за приглашённого: −{amount}',
    renewalDiscount: 'Скидка продления: −{amount}',
    /** Stage 17: оплаченные разовые места за последние две недели зачтены в цену сезона */
    singleCredit: 'Зачёт разовых мест: −{amount}',
    guarantee: 'Гарантия набора',
    guaranteeBody: 'Если к {date} не наберётся минимум оплат, деньги вернутся автоматически',
    guaranteeBodyNoDate: 'Если не наберётся минимум оплат, деньги вернутся автоматически',
    /** Сезон уже идёт (раунд 3, M2): срок продаж позади, автовозврата по гарантии нет. */
    guaranteeDone:
      'Выполнена: минимум оплат набран, сезон идёт. Ближайший сбор — {date}, по расписанию',
    guaranteeDoneNoNext: 'Выполнена: минимум оплат набран, сезон идёт по расписанию',
    /** Окно продаж закрывается после первого сбора: что с ним будет при недоборе. */
    guaranteeEarlyGathering:
      'Сбор {date} пройдёт раньше этого срока. Если минимум не наберётся, деньги вернутся целиком, и за него тоже',
    deadlineExtended: 'Оператор продлил срок оплаты',
    payCta: 'Оплатить {price}',
    payAgain: 'Открыть счёт ещё раз',
    payHint: 'Оплата картой на странице Робокассы. Робокасса пришлёт чек на почту, которую укажешь там',
    payHintManual: 'В пилоте оплата переводом: реквизиты появятся после нажатия',
    outcome: {
      cancelled: 'Оплата отменена. Счёт можно открыть ещё раз',
      failed: 'Оплата не прошла. Попробуй ещё раз или напиши в поддержку',
      pending: 'Ждём подтверждения от банка. Статус обновится сам',
    },
    alreadyPaid: 'Сезон оплачен. Место в составе закреплено',
    openReceipt: 'Детали оплаты',
    closed: 'Сезон закрыт, оплата недоступна',
    manualTitle: 'В пилоте оплата переводом',
    manualBody: 'Переведи {price} по реквизитам и напиши в поддержку',
    manualNoDetails: 'Реквизиты даст поддержка или капитан отряда',
    /**
     * Раунд 5, C1/M1: капитану и человеку без отряда — без отсылки к капитану. Правда по коду:
     * оператор пишет через бота (`admin.notifications.send`), а бот ответов не читает.
     */
    manualNoDetailsSelf:
      'Реквизитов в приложении пока нет. Сообщения от оператора приходят через бота',
    manualWaiting: 'Оператор подтвердит перевод, статус обновится на этом экране',
    support: 'Написать в поддержку',
    supportTitle: 'Поддержка',
    supportNone: 'Контакт поддержки даст капитан отряда',
    supportNoneSelf:
      'Контакта поддержки в приложении пока нет. Сообщения от оператора приходят через бота',
    /**
     * Условия возврата до оплаты (раунд 3, M3). Только то, что записано в BLUEPRINT 2.2 и
     * runbook «Возврат»: гарантия набора — карточкой выше; отмена сезона и роспуск — за
     * несостоявшиеся сборы; выход до первого сбора — возврат через поддержку; остальное — по
     * решению в спорном случае. Других оснований для возврата в системе нет.
     */
    refundTitle: 'Возврат',
    refundItems: [
      'Сбор или сезон отменили, отряд распустили — вернём за сборы, которые не состоялись',
      'Выходишь до первого сбора — напиши в поддержку, оформим возврат',
      'За пропущенный сбор деньги не возвращаются. Выход после старта — через поддержку, решаем по ситуации',
    ],
    offer: 'Публичная оферта',
    /** Раунд 4, M1: из чего состоит сезон — до оплаты */
    formatsTitle: 'Сборы сезона',
    /**
     * Раунд 4, M3: что будет без оплаты — по логике дедлайна на сервере (`lib/guarantee.ts`,
     * `unpaidNote`), одной строкой на главном и на экране оплаты
     */
    unpaidSale:
      'Оплата до {deadline}. Если к этому сроку оплатят меньше {min} из состава, сезон не начнётся: деньги вернутся всем, а отряд распустится',
    unpaidRenewal:
      'Продление до {deadline}. Если продлят меньше {pauseBelow} человек, отряд встанет на паузу, а состав вернётся в набор',
    unpaidActive: 'Сезон уже идёт: оплатить можно, пока он не закончится',
    status: 'Статус оплаты',
    toHome: 'На главный',
  },
  payResult: {
    title: 'Результат оплаты',
    paidTitle: 'Сезон оплачен',
    pendingTitle: 'Ждём оплату',
    closedTitle: 'Заказ закрыт',
    amount: 'Сумма',
    paidBody: 'Оплата получена {when}. Место в составе закреплено',
    paidBodyNoDate: 'Оплата получена. Место в составе закреплено',
    pendingInvoice: 'Заверши оплату на странице Робокассы и вернись сюда: статус обновится сам, обычно это минута',
    pendingManual: 'Перевод ждёт подтверждения оператора',
    refundedBody: 'Деньги по этому заказу возвращены. Срок зачисления — по правилам банка',
    closedBody: 'Заказ закрыт без оплаты',
    refunded: 'Возвращено: {amount}',
    nextTitle: 'Что дальше',
    nextItems: ['Расписание сезона — на главном', 'Ответь «Идёшь?» на ближайший сбор', 'Группа отряда — в Telegram'],
    backToPay: 'К оплате',
  },
  /**
   * «Мои сборы» (Stage 17, задача 7): журнал всех записей. Тон — язык записи на игры
   * (`docs/my-gatherings/decisions.md`): записаться, бронь, место за тобой («слот» → «место», раунд персон 1, N11); тексты состояний —
   * `design.md` 4.3. «Гость», «мероприятие», «корзина» не говорим.
   */
  my: {
    title: 'Мои сборы',
    docTitle: 'Мои сборы',
    tabsLabel: 'Какие записи показать',
    tabs: {
      all: 'Все',
      squad: 'Отряд',
      singles: 'Разовые',
      tournaments: 'Турниры',
      ops: 'Доп. сборы',
    },
    tabCount: '{label}, {count}',
    /** Раунд персон 2 (мелочи): турнир считается и в «Отряде» или «Разовых» — сумма вкладок больше «Все» */
    tabsOverlap: 'Турниры входят и в «Отряд» или «Разовые»',
    tabNone: '{label}, нет записей',
    nearest: 'Ближайший',
    nearestIn: 'Ближайший · через {when}',
    nearestNow: 'Идёт сейчас',
    squadNamed: 'отряд «{name}»',
    /**
     * Раунд персон 1 (M5/N8): без названия — хвост id. Раунд персон 2 (M5/N8): активность и время
     * уже есть в строке записи, поэтому здесь только то, что отличает отряд
     */
    squadUnnamed: 'отряд\u00a0№{tail}',
    relation: {
      SQUAD: 'Свой отряд',
      SUBSTITUTE: 'Замена',
      TRIAL: 'Пробный',
      SINGLE: 'Разовое место',
    },
    /** Раунд персон 1: «разовый» — только про человека на чужом месте; сбор ops своего отряда — доп. сбор */
    opsExtra: 'Доп. сбор',
    paid: 'оплачено',
    rsvp: { YES: 'Иду', NO: 'Не иду', MAYBE: 'Думаю' },
    answerUntil: 'Ответь до {date}',
    weekThis: 'Эта неделя',
    weekNext: 'Следующая неделя',
    weekRange: '{from} — {to}',
    more: 'Записаться ещё',
    moreHint: 'Свободные места в готовых отрядах',
    oneLeft: 'Дальше записей нет. Свободный вечер можно закрыть разовым местом в другом отряде.',
    emptyTitle: 'Пока никуда не записан',
    emptyBody:
      'Здесь будут сборы твоего отряда, замены, пробные и разовые места — одним списком по датам.',
    emptyBodyPool: 'Пока идёт набор отряда, можно сходить разовым местом в готовый отряд.',
    emptyAction: 'Открытые места',
    emptyActionHint: 'Там места в готовых отрядах: замена, пробный, разовое место',
    tabEmpty: {
      squad: {
        title: 'Сборов отряда впереди нет',
        body: 'Расписание сезона — на экране «Сезон». Доп. сборы, которые мы добавляем в сезон отряда, тоже будут здесь.',
        action: 'Сезон',
      },
      squadPool: {
        title: 'Отряд ещё набирается',
        body: 'Сборы сезона появятся здесь, когда состав наберётся и сезон стартует. Пока можно сходить разовым местом в готовый отряд — такие записи встанут сюда же, в список.',
        action: 'Как идёт набор',
      },
      singles: {
        title: 'Разовых записей нет',
        body: 'Здесь места в чужих отрядах. Свободный вечер можно закрыть заменой, пробным или разовым местом.',
        action: 'Открытые места',
      },
      tournaments: {
        title: 'Турниров впереди нет',
        body: 'Турнир — сбор, где отряд играет против другого отряда. Когда отряду назначат соперника или ты запишешься на турнир разовым местом, он появится здесь.',
        action: 'Открытые места',
      },
      ops: {
        title: 'Доп. сборов нет',
        body: 'Доп. сборы мы добавляем в сезон отряда. Как появится — он будет здесь.',
        action: 'Открытые места',
      },
    },
    holdTitle: 'Бронь ждёт оплаты',
    holdSummary: '{count} · {amount}',
    holdBody: 'Места за тобой до {time}. Потом они вернутся в «Открытые места».',
    holdOpen: 'Вернуться к оплате',
    /** Раунд персон 2 (N4): сборы брони строками под плашкой */
    holdItemsLabel: 'Сборы в брони',
    holdItemPending: 'ждёт оплаты',
    formatStandard: 'Турнир до конца',
    formatStandardUntil: 'Турнир до конца: до {time}',
    formatKnockout: 'На выбывание: вылетели — можно уходить',
  },
  /** Предупреждение перед записью на турнир (Stage 17; тексты — `design.md` 4.3, формат задаёт ops). */
  tournamentWarn: {
    standardBadge: 'До конца',
    standardTitle: 'Это турнир — играем до конца',
    standardBody:
      'Записываешься — остаёшься до последней игры, до {end}. Уйдёшь раньше — отряду не хватит состава на следующие игры.',
    standardBodyNoEnd:
      'Записываешься — остаёшься до последней игры. Уйдёшь раньше — отряду не хватит состава на следующие игры.',
    standardHint: 'Не уверен, что останешься до конца, — возьми обычный сбор.',
    standardConfirm: 'Понятно, буду до конца',
    knockoutBadge: 'На выбывание',
    knockoutTitle: 'Турнир на выбывание',
    knockoutBody:
      'Играешь, пока отряд в сетке. Вылетели — можно уходить, досиживать до финала не нужно.',
    knockoutFinal: 'Дойдёте до финала — это до {end}.',
    knockoutConfirm: 'Понятно, записываюсь',
    later: 'Не сейчас',
    when: '{date}, {from}–{to}',
    itemStandard: 'Турнир · до конца',
    itemKnockout: 'Турнир на выбывание',
    calloutStandard: 'Играешь до последней игры, до {end}. Уйдёшь раньше — отряду не хватит состава.',
    calloutStandardNoEnd: 'Играешь до последней игры. Уйдёшь раньше — отряду не хватит состава.',
    calloutKnockout: 'Играешь, пока отряд в сетке. Вылетели — можно уходить.',
    formatLineCaptain: 'Формат задаёт оператор. Разовым он показан перед записью',
  },
  /** Заявка `/booking/:id` и оформление `/booking/new` (Stage 17, задача 7): ведомость и квитанция. */
  booking: {
    title: 'Заявка',
    docTitle: 'Заявка',
    receiptTitle: 'Квитанция',
    receiptNumber: 'Квитанция · {date}',
    summary: '{count} · одна оплата',
    itemsTitle: 'Сборы в заявке',
    total: 'Итого',
    bonus: 'Бонус за приглашённого',
    remove: 'Убрать',
    findOther: 'Найти другой сбор',
    kind: { SINGLE: 'Разовое место', SUBSTITUTE: 'Замена', TRIAL: 'Пробный' },
    holdUntil: 'Места за тобой до {time}',
    holdHot: 'Успей оплатить',
    holdBody: 'Потом места вернутся в «Открытые места»',
    holdLeft: 'осталось',
    pay: 'Оплатить {amount} одной ссылкой',
    payHint: 'Одна ссылка Робокассы на все сборы заявки. Чек придёт на почту, которую укажешь там.',
    payAgain: 'Открыть ссылку ещё раз',
    payReturn:
      'Оплата не пришла? Если окно оплаты закрылось или платёж не прошёл, открой ссылку ещё раз — сумма и сборы те же.',
    previewHint: 'После нажатия места держатся за тобой, пока идёт оплата. Деньги спишутся только на странице Робокассы.',
    conflictTitle: 'Пересекается с твоим сбором',
    conflictBody: 'В одно время на два сбора не записаться.',
    conflictOpen: 'Открыть свой сбор',
    /** Ревью 2026-09-24: пересечение с другим пунктом этой же заявки, а не с записью человека */
    conflictInBookingTitle: 'Совпадает по времени с другим сбором заявки',
    conflictInBookingBody: 'Оставь один из двух — второй убери из заявки.',
    takenTitle: 'Место забрали',
    takenBody: 'Пока ты выбирал, место занял другой. Из итога убрали.',
    allTakenTitle: 'Все места разобрали',
    allTakenBody: 'Пока ты выбирал, места заняли. Деньги не списаны.',
    nothingTitle: 'Оплатить пока нечего',
    nothingBody: 'Выбранные сборы сейчас недоступны — причина у каждого выше. Убери их или выбери другие.',
    limitTitle: 'Разовых без сезона больше нельзя',
    unavailable: 'Недоступно',
    expiredTitle: 'Бронь снята',
    expiredBody:
      'Время на оплату вышло, места вернулись в «Открытые места». Деньги не списаны. Если они ещё свободны, соберём заявку заново из тех же сборов.',
    rebuild: 'Собрать заново',
    replacedTitle: 'Бронь дописана в новую заявку',
    /** Раунд персон 2 (M8) */
    toNewBooking: 'К новой заявке',
    replacedBody:
      'Эти сборы вошли в новую заявку вместе с добавленными — оплачивай её, она в «Моих сборах». Ссылка этой заявки больше не действует. Если деньги по ней всё же прошли, вернём их полностью.',
    /** Раунд персон 1 (M2/N1): оформление при живой брони — дописывание */
    appendTitle: 'Допишем в твою бронь',
    appendBody:
      'Сборы из брони остаются, к ним добавятся новые. Оплата — одной новой ссылкой, срок брони начнётся заново. Прежняя ссылка перестанет действовать: если уже оплатил по ней, деньги вернём.',
    fromBooking: 'уже в брони',
    nothingNewTitle: 'Всё выбранное уже в брони',
    nothingNewBody: 'Эти сборы ждут оплаты в твоей брони.',
    openBooking: 'Открыть бронь',
    /** Раунд персон 3 (N10): заявку, отправленную на оплату, нельзя было снять — лимит занят до конца брони */
    cancelBooking: 'Отменить заявку',
    cancelBookingTitle: 'Отменить заявку?',
    cancelBookingBody:
      'Места вернутся в «Открытые места», деньги не списаны. Если оплата по ссылке всё же пройдёт, вернём её полностью.',
    cancelBookingConfirm: 'Отменить заявку',
    cancelBookingKeep: 'Оставить',
    userCancelledTitle: 'Заявка снята',
    userCancelledBody:
      'Ты отменил заявку: места вернулись в «Открытые места», деньги не списаны. Если они ещё свободны, соберём заявку заново из тех же сборов.',
    opsCancelledTitle: 'Заявку закрыли',
    opsCancelledBody:
      'Оператор закрыл заявку, места вернулись в «Открытые места». Деньги не списаны.',
    stamp: 'Оплачено',
    paidLead: 'Ты в деле',
    /** Раунд персон 1 (M8): напоминания уходят за 48, 24 и 3 часа (гостям тоже, ADR-47) */
    paidBody:
      'В «Моих сборах»: {count}. Адрес — на экране сбора и в напоминании за 3 часа; бот напомнит ещё за двое суток и за сутки.',
    /** Раунд персон 1 (M1): квитанция после выписки — по живым позициям */
    stampClosed: 'Снято',
    closedLead: 'Записей по заявке не осталось',
    closedDueBody: 'Вернём {amount}: возврат оформит оператор, деньги придут в срок банка.',
    closedRefundedBody: 'Возвращено {amount}.',
    dueTotal: 'К возврату',
    refundedTotal: 'Возвращено',
    openMy: 'Открыть мои сборы',
    /** Раунд персон 2 (M6): после «Оплатить» — как на экране оплаты сезона */
    waitingTitle: 'Ждём подтверждения оплаты',
    waitingBody:
      'Заверши оплату на странице Робокассы и вернись сюда: статус обновится сам, обычно это минута.',
    manualTitle: 'В пилоте оплата переводом',
    manualBody: 'Переведи {amount} по реквизитам и напиши в поддержку. Места держим до {time}.',
    manualNoDetails: 'Реквизитов в приложении пока нет — их даст поддержка.',
    manualWaiting: 'Оператор подтвердит перевод, статус обновится на этом экране.',
    cancelRule: 'Выписаться с полным возвратом можно до {deadline}. Позже — без возврата.',
    cancelClosed: 'Меньше суток до сбора — выписаться нельзя. Если не можешь, напиши капитану.',
    cancel: 'Выписаться',
    cancelTitle: 'Выписаться со сбора?',
    cancelBody:
      '{activity}, {date}. Место вернётся в «Открытые места», а {amount} вернём полностью: возврат оформит оператор, деньги придут в срок банка.',
    cancelConfirm: 'Выписаться',
    cancelKeep: 'Остаюсь',
    cancelledNote: 'Ты выписался — вернём {amount}',
    refundDue: 'к возврату',
    refunded: 'возвращено',
    closedCancelled: 'Сбор отменён — вернём всю сумму',
    closedRescheduled: 'Сбор перенесён на другую дату — запись не переехала, вернём всю сумму',
    closedTaken: 'Место забрали до оплаты — вернём всю сумму',
    closedAlready: 'Ты уже шёл на этот сбор — вернём всю сумму',
    closedLate: 'Оплата пришла после брони — вернём всю сумму',
    emptyTitle: 'Ничего не выбрано',
    emptyBody: 'Выбери сборы в «Открытых местах» и нажми «Оформить».',
    emptyAction: 'Открытые места',
    openGathering: 'Сбор',
  },
  orderStatus: {
    PENDING: 'Ждёт оплаты',
    PAID: 'Оплачен',
    REFUNDED: 'Возвращён',
    PARTIALLY_REFUNDED: 'Частичный возврат',
    CANCELLED: 'Отменён',
    FAILED: 'Не прошёл',
  },
  levels: {
    label: ['', 'Новичок', 'Начинающий', 'Средний', 'Уверенный', 'Сильный'],
    group: 'Уровень игры',
  },
  placeholder: {
    stage: 'Экран появится в Stage {stage}',
    home: 'Ближайший сбор',
    squad: 'Отряд',
    squadReserve: 'Запасной',
    season: 'Сезон',
    gathering: 'Сбор',
    gatheringFeedback: 'Как прошёл сбор',
    paySeason: 'Оплата сезона',
    payResult: 'Результат оплаты',
    openSeats: 'Открытые места',
    invite: 'Приведи своего',
    captainGathering: 'Явка на сбор',
  },
  roster: {
    freeSeat: 'Место свободно',
    captain: 'Капитан',
    reserve: 'Запасной',
    you: 'Ты',
    level: 'ур. {level}',
    age: '{age}',
    count: '{filled} из {capacity}',
  },
  /** Названия знаков отряда: подписи кнопок выбора и озвучка для скринридера. */
  emblems: {
    shield: 'Щит',
    flame: 'Пламя',
    bolt: 'Молния',
    anchor: 'Якорь',
    axe: 'Топор',
    bear: 'Медведь',
    wolf: 'Волк',
    falcon: 'Сокол',
    boar: 'Кабан',
    lion: 'Лев',
    compass: 'Компас',
    mountain: 'Гора',
    wave: 'Волна',
    pine: 'Сосна',
    star: 'Звезда',
    crown: 'Корона',
    hammer: 'Молот',
    horns: 'Рога',
    arrow: 'Стрела',
    fist: 'Кулак',
    gear: 'Шестерня',
    torch: 'Факел',
    rook: 'Ладья',
    flag: 'Флаг',
  } as Record<string, string>,
  schedule: {
    gatheringN: 'Сбор {n}',
    /** Раунд персон 1, C2: доп. сбор (Stage 12 или сбор ops) — без номера, он вне шести сборов сезона */
    extra: 'Доп. сбор',
    statusPlanned: 'Запланирован',
    statusConfirmed: 'Подтверждён',
    statusDone: 'Прошёл',
    statusCancelled: 'Отменён',
    rsvpQuestion: 'Идёшь?',
    rsvpYes: 'Иду',
    rsvpNo: 'Не иду',
    rsvpMaybe: 'Думаю',
    attendanceWent: 'Ты был',
    attendanceMissed: 'Пропустил',
  },
  countdown: {
    days: '{d} д {h} ч',
    hours: '{h} ч {m} мин',
    minutes: '{m} мин',
    now: 'Сейчас',
    passed: 'Прошло',
  },
  stepper: {
    step: 'Шаг {current} из {total}',
  },
  devUi: {
    title: 'Витрина компонентов',
    subtitle: 'Только для разработки. Роут /dev/ui недоступен в production',
    apiStatus: 'Связь с API',
    apiOk: 'API отвечает',
    apiFail: 'API не отвечает',
    checking: 'Проверяю',
    version: 'Версия',
    authTitle: 'auth.me',
    tmaTitle: 'Окружение Telegram',
    mockEnv: 'Вне Telegram: окружение подменено для разработки',
    tmaEnv: 'Внутри Telegram',
    platform: 'Платформа',
    startParam: 'start_param',
    resetOnboarding: 'Сбросить черновик онбординга',
    sections: {
      buttons: 'Button',
      cards: 'Card и ListRow',
      chips: 'Chip',
      stepper: 'Stepper',
      roster: 'RosterGrid',
      schedule: 'ScheduleRow',
      badges: 'StatusBadge',
      countdown: 'Countdown',
      sheet: 'Sheet',
      states: 'Состояния',
      haptics: 'Хаптика',
      mainButton: 'MainButton',
    },
    openSheet: 'Открыть шторку',
    sheetTitle: 'Нижняя шторка',
    sheetBody: 'Подтверждение действия, выбор варианта, детали сбора',
    hapticImpact: 'Удар',
    hapticSuccess: 'Успех',
    hapticSelection: 'Выбор',
    mainButtonText: 'Главное действие',
    mainButtonToggle: 'Показать MainButton',
    mainButtonPressed: 'MainButton нажат',
  },
} as const;

export type Texts = typeof texts;

/** Подстановка `{key}` в строку: `fmt(texts.roster.age, { age: 32 })`. */
export function fmt(template: string, params: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => String(params[key] ?? `{${key}}`));
}

/** Текст ошибки API по машинному коду `error.data.reason`; фолбэк — общая ошибка. */
/**
 * Экраны передают сюда запасной строкой текст ошибки от сервера, а при непройденной проверке
 * входа tRPC кладёт в него JSON массива issues zod. Показывать такой дамп человеку нельзя.
 */
function zodMessage(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('[')) return null;
  try {
    const issues: unknown = JSON.parse(trimmed);
    if (!Array.isArray(issues)) return null;
    const messages = issues
      .map((i) => (i && typeof i === 'object' ? (i as { message?: unknown }).message : null))
      .filter((m): m is string => typeof m === 'string' && m.length > 0);
    return messages.length ? messages.join('. ') : null;
  } catch {
    return null;
  }
}

/**
 * Отказ по доступу: повторять запрос бессмысленно — ответ не изменится, и кнопка «Повторить»
 * рядом с «Это делает капитан» только сбивает с толку.
 */
const ACCESS_REASONS = new Set([
  'not_captain',
  'venue_account',
  'need_role',
  'owner_only',
  'need_venue_role',
  'account_blocked',
  'unauthorized',
  'squad_required',
]);

export function isAccessDenied(reason: unknown): boolean {
  return typeof reason === 'string' && ACCESS_REASONS.has(reason);
}

export function errorText(reason: unknown, fallback: string = texts.common.errorBody): string {
  if (typeof reason === 'string' && reason in texts.errors) {
    return texts.errors[reason as keyof typeof texts.errors];
  }
  return zodMessage(fallback) ?? fallback;
}

/** Русское склонение после числа: «1 сбор», «3 сбора», «6 сборов». */
export function plural(n: number, forms: readonly [string, string, string]): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return `${n} ${forms[2]}`;
  if (last > 1 && last < 5) return `${n} ${forms[1]}`;
  if (last === 1) return `${n} ${forms[0]}`;
  return `${n} ${forms[2]}`;
}

export const PLURAL_YEARS = ['год', 'года', 'лет'] as const;
export const PLURAL_DAYS = ['день', 'дня', 'дней'] as const;
export const PLURAL_PEOPLE = ['человек', 'человека', 'человек'] as const;
export const PLURAL_GATHERINGS = ['сбор', 'сбора', 'сборов'] as const;
export const PLURAL_SEASONS = ['сезон', 'сезона', 'сезонов'] as const;
/** «до 1 места», «до 2 мест» — после «до» родительный падеж */
export const PLURAL_SEATS_UPTO = ['места', 'мест', 'мест'] as const;

/** Месяц тремя буквами по номеру 0–11: «ноя» (раунд персон 2). */
export function monthShort(month: number): string {
  return texts.months.short[month] ?? String(month + 1);
}

/** День недели с предлогом: «во вторник», «в среду». */
export function weekdayOn(day: number): string {
  return texts.weekdays.on[day - 1] ?? String(day);
}

export function weekdayShort(day: number): string {
  return texts.weekdays.short[day - 1] ?? String(day);
}

export function weekdayLong(day: number): string {
  return texts.weekdays.long[day - 1] ?? String(day);
}

export function weekdaysShort(days: readonly number[]): string {
  return days.map(weekdayShort).join(', ');
}

/**
 * Уровень набора словом (раунд 4, N2/N8): «уровень: средний» вместо «уровень 3». У активности
 * без уровня полоса нейтральная — пишем «любой уровень», а не выдуманную тройку.
 */
export function cellLevelText(band: number, leveled: boolean): string {
  if (!leveled) return texts.pool.levelAny;
  const name = texts.levels.label[band];
  return name
    ? fmt(texts.pool.levelNamed, { name: name.toLowerCase() })
    : fmt(texts.pool.cellLevel, { level: band });
}

/** Уровень одним словом для строки «Уровень» — без повтора подписи. */
export function levelName(band: number, leveled: boolean): string {
  if (!leveled) return texts.pool.levelAny;
  return texts.levels.label[band] ?? String(band);
}
